<template>
  <v-container class="start-page site-layout pa-0" fluid>
    <v-row no-gutters>

      <!-- Banner -->
      <div class="figure">
        <div :class="{ 'img-adler-vor-login': !this.$store.getters.isAuthenticated }" class="img-adler">

          <!-- Registration Overlay --->
          <div v-if="!this.$store.getters.isAuthenticated && !smallScreen"
               class="registration-overlay-outer">
            <div class="registration-overlay-inner secondary round-corners">
              <p>
                Sie möchten die Vorteile <br> im Maklerportal nutzen?<br>
              </p>
              <v-btn class="ma-2"
                     @click="$router.push('register')">
                Jetzt registrieren
                <v-icon>keyboard_arrow_right</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </div>


      <!-- Darum DMB-Rechtschutz Bereich (nur falls nicht eingeloggt) -->

      <div v-if="!this.$store.getters.isAuthenticated"
           class="section">

        <template v-if="smallScreen">

          <v-row class="register-box-container" no-gutters>

            <div class="register-box primary round-corners"
                 @click="$router.push('login')">
              <p>
                Zugang zum Maklerportal <br> für registrierte Makler.<br>
              </p>
              <v-btn class="ma-2">Login
                <v-icon>keyboard_arrow_right</v-icon>
              </v-btn>
            </div>

            <div class="register-box secondary round-corners"
                 @click="$router.push('register')">
              <p>
                Sie möchten die Vorteile <br> im Maklerportal nutzen?<br>
              </p>
              <v-btn class="ma-2">Jetzt registrieren
                <v-icon>keyboard_arrow_right</v-icon>
              </v-btn>
            </div>

          </v-row>

        </template>

        <div class="ueber primary--text">Darum DMB Rechtsschutz
        </div>

        <v-row class="content"
               no-gutters>

          <!-- Left Side Items -->
          <v-col cols="12"
                  md="6">
            <div class="custom-list-item">
              <div class="custom-list-sub">Konzernunabhängigkeit</div>
              <div class="custom-list-item-sub">Maximale Sicherheit, keine Interessenkollisionen mit anderen Sparten</div>
            </div>
            <div class="custom-list-item">
              <div class="custom-list-sub">Schnelle, unkomplizierte Abläufe</div>
              <div class="custom-list-item-sub">Wir unterstützen Sie bei allen Themen rund um Rechtsschutz - freundlich und unbürokratisch</div>
            </div>
            <div class="custom-list-item">
              <div class="custom-list-sub">Wir setzen uns für Sie ein</div>
              <div class="custom-list-item-sub">Als Gründungsmitglied der Bundesarbeitsgemeinschaft zur Förderung der Versicherungsmakler (BFV)</div>
            </div>
          </v-col>

          <!-- Right Side Items -->
          <v-col :class="{'mt-6': $vuetify.breakpoint.smAndDown}"
                 cols="12"
                 md="6">
            <div class="custom-list-item">
              <div class="custom-list-sub">Herausragende Leistungen</div>
              <div class="custom-list-item-sub">Mehrfach ausgezeichnetes Preis-Leistungs-Verhältnis und wertvolle Serviceleistungen</div>
            </div>
            <div class="custom-list-item">
              <div class="custom-list-sub">Persönliche Ansprechpartner</div>
              <div class="custom-list-item-sub">Wir sind für Sie da: Vor Ort und bei unserer
                <span style="white-space:nowrap">Makler-Hotline</span></div>
            </div>
            <div class="custom-list-item">
              <div class="custom-list-sub">Innovative Web-Technologien</div>
              <div class="custom-list-item-sub">Online Abschlüsse und Verwaltung - einfach, schnell, jederzeit verfügbar</div>
            </div>
          </v-col>

        </v-row>

      </div>

      <!-- Angebotsrechner Privatkunden (nur falls eingeloggt) -->

      <div v-if="this.$store.getters.isAuthenticated"
           class="section">

        <div class="ueber primary--text">Angebotsrechner Privatkunden
        </div>

        <v-row class="content section-link1"
               no-gutters
               @click="$router.push('privatkunden')">

          <!-- Left Side Items -->
          <v-col cols="12"
                 md="4">
            <a class="center-cropped-container">
              <img src="../../assets/zahnrad.jpg"
                   class="center-cropped">
            </a>
          </v-col>

          <!-- Center Items -->
          <v-col cols="12"
                 md="5">
            <div class="custom-list-item">
              <div class="custom-list-sub">Privat, Beruf, Wohnung, Verkehr</div>
              <div class="custom-list-item-sub">
                <p>Erstellen Sie schnell und unkompliziert <br> ein Angebot für Ihre Privatkunden</p>
              </div>
            </div>
          </v-col>

        </v-row>

      </div>

      <!-- Angebotsrechner Geschäftskunden (nur falls eingeloggt) -->

      <div v-if="this.$store.getters.isAuthenticated"
           class="section">

        <div class="ueber primary--text">Angebotsrechner Geschäftskunden
        </div>

        <v-row class="content"
               no-gutters>

          <!-- Left Side Items -->
          <v-col v-if="$store.getters.checkPageAuthorization('Gewerbekunden')"
                 cols="12"
                 md="4"
                 class="section-link2"
                 @click="$router.push('/gewerbekundenangebot')">
            <a class="center-cropped-container">
              <img src="../../assets/haus.jpg"
                   class="center-cropped">
            </a>
            <div class="custom-list-item">
              <div class="custom-list-sub">KOMPEX</div>
              <div class="custom-list-item-sub">
                Umfassender Rechtsschutz für Selbstständige / Gewerbetreibende - auch im privaten Bereich
              </div>
            </div>
          </v-col>

          <!-- Center Items -->
          <v-col v-if="$store.getters.checkPageAuthorization('Aerzte')"
                 :class="{'mt-6': $vuetify.breakpoint.smAndDown}"
                  cols="12"
                  md="4"
                  class="section-link2"
                  @click="$router.push('/komedex')">
            <a class="center-cropped-container">
              <img src="../../assets/herz.jpg"
                   class="center-cropped">
            </a>
            <div class="custom-list-item">
              <div class="custom-list-sub">KOMedEX</div>
              <div class="custom-list-item-sub">
                Maßgeschneidert und leistungsstark für Ärzte und Heilberufe
              </div>
            </div>
          </v-col>

          <!-- Right Side Items -->
          <v-col :class="{'mt-6': $vuetify.breakpoint.smAndDown}"
                  cols="12"
                  md="4"
                  class="section-link2"
                  @click="$router.push('/landwirtschaft')">
            <a class="center-cropped-container">
              <img src="../../assets/agromex.jpg"
                   class="center-cropped">
            </a>
            <div class="custom-list-item">
              <div class="custom-list-sub">AGROMEX</div>
              <div class="custom-list-item-sub">
                Besonderes Komplettpaket für
                <br :class="$vuetify.breakpoint.mdAndUp ? '' : 'show-br'"> Land- und Forstwirte
              </div>
            </div>
          </v-col>

        </v-row>

      </div>


      <!-- Online Schulungen (Recht Online) und NEWS Bereich -->

      <div class="section">

        <v-row id="section-online"
               class="content"
               no-gutters>

          <!--  Links: Online Schulungen -->
          <v-col cols="12"
                 md="6">

            <div class="ueber">
              <a target="_blank"
                 href="https://anmeldung.csn.de/dmb-rechtsschutz">
                <img src="../../assets/Start2_or.jpg"
                     width="200">
              </a>
            </div>

            <div class="custom-list-item">
              <div class="custom-list-sub">Online-Schulungen</div>
              <div class="custom-list-item-sub small">
                <p>Für guten Rechtsschutz gibt es viele Argumente und den richtigen Weg. Informieren Sie sich in unseren exklusiven Online-Schulungen über Produkt-Highlights der DMB Rechtsschutz, Verkaufsargumente und Schadenbeispiele aus der Praxis. 
                </p>
                <p>Die Dauer unserer Online-Schulungen beträgt jeweils ca. 50 Minuten. Die Beschreibung der jeweiligen Schulung erhalten Sie mit der Einladung.
                </p>
              </div>
            </div>

            <v-btn color="primary"
                   target="_blank"
                   href="https://anmeldung.csn.de/dmb-rechtsschutz"
                   class="ma-0">Jetzt anmelden
              <v-icon>keyboard_arrow_right
              </v-icon>
            </v-btn>

          </v-col>

          <!-- Rechts: News Bereich -->
          <v-col cols="12"
                 md="6">

            <div class="ueber">
              <v-toolbar color="primary white--text"
                         dense
                         flat>
                <v-toolbar-title>NEWS</v-toolbar-title>
              </v-toolbar>
            </div>

            <loading-data-page-container
              :loading="!isInitialized && !loadingError"
              :loading-error="loadingError"
              :loading-error-message="loadingErrorMessage"
              :hint="loadingErrorHint">

              <template v-if="isInitialized && !loadingError">

                <div class="news-list">
                  <div v-for="(newsItem, index) in StartseiteNews.items"
                       :key="'NewsItem' + index"
                       class="custom-list-item">
                    <div class="news-list-item-topic secondary--text"> {{ newsItem.title }}
                    </div>
                    <div> {{ newsItem.subtitle }}
                      <template v-if="newsItem.link && $store.state.staticPagesContent.EmptyPdf !== newsItem.link">
                        <br>
                        <a :href="newsItem.link"
                           target="_blank"> > mehr
                        </a>
                      </template>
                    </div>
                  </div>
                </div>

              </template>
            </loading-data-page-container>
          </v-col>
        </v-row>

      </div>


      <!-- Auszeichnungen -->

      <div id="section-auszeichnungen"
           class="section">

        <div class="custom-list-sub">Auszeichnungen
        </div>

        <loading-data-page-container
          :loading="!isInitialized && !loadingError"
          :loading-error="loadingError"
          :loading-error-message="loadingErrorMessage"
          :hint="loadingErrorHint">

          <template v-if="isInitialized && !loadingError">

            <v-row class="content"
                   no-gutters>

              <v-col v-for="(auszeichnungItem, index) in StartseiteAuszeichnungen.items"
                     :key="'AuszeichnungItem' + index"
                     :class="{'mt-6': $vuetify.breakpoint.smAndDown && index > 0 || index > 2}"
                     cols="12"
                     md="4"
                     class="pr-2 pa-0 auszeichnung">
                <a v-if="auszeichnungItem.link"
                   :href="auszeichnungItem.link"
                    target="_blank">
                  <img :src="auszeichnungItem.src" width="200px">
                </a>
                <img v-else :src="auszeichnungItem.src" width="200px">
              </v-col>

            </v-row>

          </template>

        </loading-data-page-container>

      </div>

    </v-row>
  </v-container>
</template>
<script>
import httpService from '../../helper/httpService';
import contentLoadingMixin from "@/components/helper/contentLoadingMixin";
import LoadingDataPageContainer from "@/components/kundenverwaltung/LoadingDataPageContainer";

export default {
  components: { LoadingDataPageContainer },
  mixins: [contentLoadingMixin(["StartseiteNews", "StartseiteAuszeichnungen"])],
  props: {
    doLogout: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      showAllNews: false,
      adlertoggle: true,
    };
  },
  computed: {
    smallScreen () {
      return this.$vuetify.breakpoint.width <= 1100 || this.$vuetify.breakpoint.height <= 800;
    }
  },
  mounted: function () {
    if (this.doLogout) {
      this.$store.dispatch("logout").then(() => {
        return httpService.logout();
      })
        .catch(err => {
          console.log(`LOGOUT failed with ${err.message}`);
        });
    }

    //reset css scroll behavior
    document.getElementById("navbar").classList.remove('scroll-down-navbar');
    document.getElementById("contentInner").classList.remove('scroll-down');
    let menus = document.getElementsByClassName("menu-content-open");
    Array.prototype.forEach.call(menus, function (menu) {
      menu.classList.remove('scroll-down-navbar');
    });

    // check if edge supports object-fit and if not, fix it
    if (!CSS.supports('object-fit', 'cover')) {
      let imgContainers = document.getElementsByClassName("center-cropped-container");
      for (let i = 0; i < imgContainers.length; i++) {
        let container = imgContainers[i];
        let src = container.firstChild.src;

        if (src) {
          container.style.backgroundImage = `url('${src}')`;
          container.classList.add('fix-object-fit');
        }
      }
    }
  }
};
</script>
<style>

.auszeichnung {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
}

.auszeichnung img {
  width: 200px;
}

.start-page .section-link1, .start-page .section-link2 {
  position: relative;
  cursor: pointer;
}

.start-page .section-link1 {
  pointer-events: none;
}

.start-page .section-link1 > div[class*=col-] {
  pointer-events: all;
}

.start-page .section-link1:hover::before, .start-page .section-link2:hover::before {
  content: "";
  position: absolute;
  top: -16px;
  bottom: -16px;
  left: 16px;
  right: -16px;
  background-color: rgba(0, 0, 0, 0.05) !important;
  opacity: 0.8;
  cursor: pointer !important;
  pointer-events: none;
}

.start-page .section-link1:hover::before {
  right: unset;
  width: 100%;
  max-width: 800px;
}

.start-page .news-list {
  font-size: 12pt;
}

.start-page .news-list-item-topic {
  font-weight: bold;
}

.start-page.site-layout {
  margin: -88px 0 100px 0;
  display: flex;
  justify-items: center;
}

.start-page .figure {
  width: 100vw;
  min-width: 100vw;
  max-height: 520px;
  overflow: hidden;
  margin: 0;
}

@media only screen and (min-width: 1280px) {
  .start-page .figure {
    margin-left: calc((100vw - 1280px) / 2 * (-1));
  }
}

.start-page .figure .img-adler {
  background-image: url("../../assets/Keyvisual_Adler.jpg");
  background-size: cover;
  background-position: center;
  margin: 0 0 0 0;
  display: block;
  width: 100%;
  min-height: 472px;
}

@media screen and (min-width: 1101px) and (min-height: 801px) {
  .start-page .figure .img-adler-vor-login {
    background-image: url("../../assets/Keyvisual_Adler_vorLogin.jpg");
  }
}

.start-page .registration-overlay-outer {
  max-width: 1280px;
  margin: 0 auto;
  position: relative;
  height: inherit;
  min-height: inherit;
}

.start-page .registration-overlay-inner {
  position: absolute;
  bottom: 24px;
  left: 48px;
  color: white;
  font-size: 18pt;
  padding: 16px 24px 16px 24px;
  width: 340px;
}

@media only screen and (min-width: 1280px) {
  .start-page .figure {
    margin-left: calc((100vw - 1280px) / 2 * (-1));
  }

  .start-page .registration-overlay-inner {
    left: 96px !important;
  }
}

.start-page .register-box-container {
  display: flex;
  justify-content: center;
  padding: 40px 0 0 48px;
}

.start-page .register-box {
  color: white;
  font-size: 18pt;
  padding: 16px 24px 16px 24px;
  max-width: 340px;
  min-width: 328px;
  margin: 16px 24px;
  cursor: pointer;
}

.start-page .register-box .v-btn {
  min-width: 196px;
}

.start-page .register-box .btn .v-icon {
  position: absolute;
  right: 8px;
}

.start-page .section {
  max-width: 1184px;
  width: 100%;
  margin: 0 auto;
  padding: 0 96px 0 48px;

}

.start-page .section .ueber {
  margin: 40px 0 24px 0;
}

.start-page .section .ueber img {
  margin-left: 48px;
}

.start-page .section .content > div[class*=col-] {
  padding-left: 32px;
}

.start-page #section-auszeichnungen {
  margin-top: 48px;
  padding-left: 72px;
}

.start-page #section-online {
  margin-top: 48px;
}

.start-page #section-auszeichnungen .custom-list-sub {
  margin: 40px 0 24px 0;
}

.start-page .center-cropped {
  object-fit: cover; /* Do not scale the image */
  object-position: center; /* Center the image within the element */
  height: 204px;
  width: 100%;
  margin-bottom: 16px;
}

.start-page .custom-list-item {
  margin: 0 0 24px 0;
}

.start-page .news-list .custom-list-item {
  margin: 0 0 16px 0;
}

.start-page .custom-list-item:last-child, .news-list .custom-list-item:last-child {
  margin: 0 !important
}

.start-page .custom-list-sub {
  font-size: 17pt;
}

.start-page .custom-list-item-sub {
  margin: 8px 0 0 0;
  font-size: 14pt;
}

.start-page .custom-list-item-sub.small {
  margin: 8px 0 0 0;
  font-size: 12pt;
}

.start-page a {
  text-decoration: none !important;
}

.show-br {
  display: none;
}

/*workaround for edge: object-fit*/
.center-cropped-container.fix-object-fit {
  display: block;
  height: 204px;
  width: 100%;
  background-size: cover;
  background-position: center center;
}

.center-cropped-container.fix-object-fit img {
  opacity: 0;
}

.start-page .toolbar {
  box-shadow: none !important;
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.start-page .loading--page--container {
  margin-bottom: 0!important;
}

.start-page #progress {
  top: initial !important;
  margin-top: 40px;
}

.start-page .success-failure-display-container {
  min-width: initial;
  width: 100%;
  max-width: 768px;
}

.start-page .success-failure-display  {
  margin-top: 0;
  margin-bottom: 24px;
}

.start-page .success-failure-display span {
  padding-left: 16px;
  padding-right: 0;
}

</style>
